
import { brandColors as colors } from "@/lib/palette";

export default function Blob({
  className = "",
  color = colors.lavender,
}: {
  className?: string;
  color?: string;
}) {
  return (
    <div
      className={`absolute rounded-full blur-3xl pointer-events-none ${className}`}
      style={{ backgroundColor: color, opacity: 0.18 }}
    />
  );
}
